module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-background"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3"
  }, [_c('div', {
    staticClass: "loginForm"
  }, [_c('img', {
    attrs: {
      "src": "/static/logo/AlarmBot_Logo-outline.svg",
      "title": _vm.getTranslation('app_title')
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3"
  }, [_c('div', {
    staticClass: "loginForm"
  }, [_c('alert-warning', {
    attrs: {
      "show": _vm.showAlertWarning,
      "label": _vm.lblLoginFailed,
      "btnClose": true
    },
    on: {
      "closeAlertWarning": function($event) {
        _vm.closeAlertWarning()
      }
    }
  }), _vm._v(" "), _c('alert-no-input', {
    attrs: {
      "show": _vm.showFormWarning,
      "label": _vm.getTranslation('warning_lbl_all_required'),
      "btnClose": true
    },
    on: {
      "closeAlertWarning": function($event) {
        _vm.closeAlertNoInput()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "well"
  }, [_c('h3', [_vm._v("\n                            " + _vm._s(_vm.getTranslation('mob_reset_headline')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('mob_new_password')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "autocomplete": "new-password",
      "formControlName": "password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.getTranslation('mob_lbl_action_change_password')) + "\n                            ")])])])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8f442e94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/public/components/user/Reset.vue
// module id = 697
// module chunks = 0